<div class="home">
  <div class="header">
    <div class="inside">
      <div id="logo"><a routerLink="/" title="Startseite"><img ngSrc="./assets/logo.jpg" alt="DRIVOSOL® Tuner"
                                                               height="225" width="553"></a></div>
      <div id="evonik_logo"><img ngSrc="./assets/evonik_logo.png" alt="Evonik" height="76" width="294"></div>
    </div>
  </div>
  <div class="section">
    <div class="inside">
      <div class="content-text" i18n="@@legal_content">
        <h2>LEGAL NOTICE</h2>

        <b>Content</b>

        <p>
          The information on this website is purely for the purpose of presenting our company (see company information) and our products and services. Our information is based on our present knowledge and experience to the best of our knowledge. However, it implies no liability or other legal responsibility on our part and we expressly disclaim any representations and warranties of any kind, in particular as to completeness, accuracy and continuous availability. No warranty, whether express or implied, or guarantee in the legal sense, regarding our products and services is intended or implied.
        </p>

        <p>
          We recommend that you seek professional verification of any information obtained from this website before using it. Users of this website agree to access the website and its content at their own risk. We do not assume liability for damage of any kind or nature incurred in connection with the use of this website, provided that we did not intentionally cause such damage and no further mandatory liability exists on our part.
        </p>

        <p>
          Copyright and Intellectual Property Rights<br>
          The content of this website, in particular all texts, images, graphics, logos, webcam images, sound, video and animated files, as well as their arrangement (herein “Content”), are subject to copyright law and other laws protecting intellectual property.
        </p>

        <p>
          The Content may not be duplicated, disseminated, modified and/or made available to the public unless permitted under applicable copyright laws. In particular, use of the Content on other websites is prohibited. Copies of the Content for private use must reference our copyright.
        </p>

        <p>
          Hyperlinks may only be set up to this website after receiving our prior consent. To obtain such consent, please refer to the contact person for this website named in the “Company Information”.
        </p>

        <p>
          This website does not grant any right of use to intellectual property rights, i.e. trademarks and patents. Without explicit written permission, such use, including without limitation commercial use, is prohibited and constitutes a breach of applicable law.
        </p>

        <p>
          Unless otherwise marked or in any other way identifiable, all brands and logos mentioned or used on this website are legally protected trademarks of the Evonik group, irrespective whether or not marked with the symbol ®. This particularly applies for the trade name EVONIK.
        </p>
      </div>
    </div>
  </div>
</div>
